import { Component, computed, input } from '@angular/core';

export type IndicadorTrend = 'up' | 'down' | 'neutral';

@Component({
  selector: 'app-indicador-card',
  imports: [],
  templateUrl: './indicador-card.component.html',
  styleUrl: './indicador-card.component.scss',
})
export class IndicadorCardComponent {
  readonly label = input.required<string>();
  readonly value = input.required<string>();
  readonly trend = input<IndicadorTrend | undefined>(undefined);

  readonly trendLabel = computed(() => {
    const direction = this.trend();
    if (direction === 'up') {
      return 'Tendência de alta';
    }
    if (direction === 'down') {
      return 'Tendência de baixa';
    }
    if (direction === 'neutral') {
      return 'Tendência estável';
    }
    return null;
  });
}
